import { CheckedAddress } from '@sparkdotfi/common-universal'

import { SparkLendBanner } from '../components/sparklend-banner/SparkLendBanner'
import { ConvertPointsPanel } from '@/features/points/components/convert-points-panel/ConvertPointsPanel'
import { PointsEarningsPanel } from '@/features/points/components/points-earnings-panel/PointsEarningsPanel'
import { PointsHeader } from '@/features/points/components/points-header/PointsHeader'
import { PointsLeaderboard } from '@/features/points/components/points-leaderboard/PointsLeaderboard'
import { selectSeasonValue } from '@/features/points/helpers'
import { UseSparkPointsResult } from '@/features/points/logic/useSparkPoints'
import { PageLayout } from '@/ui/layouts/PageLayout'

interface PointsViewProps extends UseSparkPointsResult {
  userChainId: number
  account: CheckedAddress
}

export function PointsView({
  userChainId,
  points,
  pointsSeason,
  previousPointsSeason,
  season1TotalPoints,
  season2TotalPoints,
  season3TotalPoints,
  claimableSpk,
  claimedSpk,
  invitedUsers,
  leaderboardPosition,
  account,
  openClaimDialog,
  openReferralShareDialog,
  onBuy,
  convertPointsPanelAction,
  onSwitchToMainnet,
  showSparkLendBanner,
}: PointsViewProps) {
  const leaderboardTotalPoints = selectSeasonValue(pointsSeason, {
    2: season2TotalPoints,
    3: season3TotalPoints,
  })
  const convertPanelVariant = selectSeasonValue(pointsSeason, {
    2: 'season-2' as const,
    3: 'season-3' as const,
  })

  return (
    <PageLayout>
      <PointsHeader pointsSeason={pointsSeason} />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[11fr_5fr]">
        <div className="grid grid-cols-1 gap-5">
          {showSparkLendBanner && <SparkLendBanner />}
          <PointsEarningsPanel
            userChainId={userChainId}
            invitedUsers={invitedUsers}
            pointsEarnings={points}
            previousPointsSeason={previousPointsSeason}
            onInvite={openReferralShareDialog}
            onBuy={onBuy}
            isGuestMode={false}
          />
          <PointsLeaderboard
            totalPoints={leaderboardTotalPoints}
            position={leaderboardPosition}
            walletAddress={account}
          />
        </div>
        <ConvertPointsPanel
          variant={convertPanelVariant}
          season1TotalPoints={season1TotalPoints}
          season2TotalPoints={season2TotalPoints}
          season3TotalPoints={season3TotalPoints}
          claimableSpk={claimableSpk}
          claimedSpk={claimedSpk}
          onClaim={openClaimDialog}
          onSwitchToMainnet={onSwitchToMainnet}
          convertPointsPanelAction={convertPointsPanelAction}
        />
      </div>
    </PageLayout>
  )
}
